import React from 'react';
import PropTypes from 'prop-types';

import { AVATAR_SIZE_18 } from '../../../../constants/avatar-sizes';
import Avatar from '../../Avatar';

const propTypes = {
  accountReaction: PropTypes.shape({
    account_profile: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      username: PropTypes.string,
      friend_status: PropTypes.shape({
        is_friend: PropTypes.bool,
      }),
    }),
    system_sticker: PropTypes.shape({
      id: PropTypes.string,
      asset_image: PropTypes.shape({
        id: PropTypes.string,
        url: PropTypes.string,
      }),
    }),
  }),
};

const AccountReactionItem = ({ accountReaction }) => {
  return (
    <div className="account-reaction-item">
      <div className="account-reaction-item-reaction-details">
        <img
          className="account-reaction-item-reaction"
          src={accountReaction.system_sticker.asset_image.url}
          alt=""
        />
        <Avatar
          className="account-reaction-item-avatar"
          photo={accountReaction.account_profile.avatar_photo}
          size={AVATAR_SIZE_18}
        />
      </div>

      <div className="account-reaction-item-account-details">
        <span className="text-extra-bold text-dark">
          {accountReaction.account_profile.name}
        </span>
        <div className="text-sm d-flex align-items-center">
          <a
            href={`/@${accountReaction.account_profile.username}`}
            className="btn-reset"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>@{accountReaction.account_profile.username}</span>{' '}
          </a>
          {accountReaction.account_profile.friend_status.is_friend && (
            <>
              {' '}
              <span className="mx-1 text-xs d-flex">&#9679;</span>
              <span className="text-primary text-sm">Friends</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

AccountReactionItem.propTypes = propTypes;

export default AccountReactionItem;
